import _extends from "@babel/runtime/helpers/esm/extends";
// this file has been generated using SVGR.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.136 22.273a6.136 6.136 0 113.858-1.364h10.012a6.136 6.136 0 113.857 1.364H7.136zm0-1.364a4.773 4.773 0 100-9.545 4.773 4.773 0 000 9.545zm22.5-4.773a4.773 4.773 0 11-9.545 0 4.773 4.773 0 019.545 0z",
    fill: "currentColor"
  }));
};

var SvgVoicemail = styled(SvgComponent).withConfig({
  displayName: "Voicemail__SvgVoicemail",
  componentId: "ie5ibk-0"
})(["", " ", ""], size, color);
export default SvgVoicemail;